(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $cd5a47cf8ef6d766$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $ad1c00e896d27009$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $cd5a47cf8ef6d766$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.state = [
            [
                null,
                null,
                null,
                null
            ],
            [
                null,
                null,
                null,
                null
            ],
            [
                null,
                null,
                null,
                null
            ],
            [
                null,
                null,
                null,
                null
            ]
        ];
        this.score = 0;
        this.status = "idle";
        this.moved = false;
        this.nextCellId = 1;
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "getState",
            value: function getState() {
                return this.state;
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                var stateCopy = this.state.map(function(row) {
                    return row.map(function(cell) {
                        return cell ? (0, $ad1c00e896d27009$export$71511d61b312f219)({}, cell) : null;
                    });
                });
                var transitions = [];
                this.moved = false;
                for(var i = 0; i < stateCopy.length; i++){
                    var merged = [
                        false,
                        false,
                        false,
                        false
                    ];
                    for(var j = 0; j < stateCopy[i].length; j++){
                        if (stateCopy[i][j] === null) continue;
                        var k = j;
                        while(k > 0 && stateCopy[i][k - 1] === null)k--;
                        if (k !== j) {
                            stateCopy[i][k] = stateCopy[i][j];
                            stateCopy[i][j] = null;
                            this.moved = true;
                            transitions.push({
                                id: stateCopy[i][k].id,
                                type: "move",
                                from: [
                                    i,
                                    j
                                ],
                                to: [
                                    i,
                                    k
                                ]
                            });
                        }
                        if (k > 0 && stateCopy[i][k - 1] !== null && stateCopy[i][k].value === stateCopy[i][k - 1].value && !merged[k - 1]) {
                            transitions.push({
                                id: stateCopy[i][k].id,
                                type: "merge",
                                from: [
                                    i,
                                    k
                                ],
                                to: [
                                    i,
                                    k - 1
                                ],
                                mergeIntoId: stateCopy[i][k - 1].id
                            });
                            stateCopy[i][k - 1].value *= 2;
                            this.score += stateCopy[i][k - 1].value;
                            stateCopy[i][k] = null;
                            merged[k - 1] = true;
                            this.moved = true;
                        }
                    }
                }
                return {
                    newState: stateCopy,
                    transitions: transitions,
                    moved: this.moved
                };
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var stateCopy = this.state.map(function(row) {
                    return row.map(function(cell) {
                        return cell ? (0, $ad1c00e896d27009$export$71511d61b312f219)({}, cell) : null;
                    });
                });
                var transitions = [];
                this.moved = false;
                for(var i = 0; i < stateCopy.length; i++){
                    var merged = [
                        false,
                        false,
                        false,
                        false
                    ];
                    for(var j = stateCopy[i].length - 1; j >= 0; j--){
                        if (stateCopy[i][j] === null) continue;
                        var k = j;
                        while(k < stateCopy[i].length - 1 && stateCopy[i][k + 1] === null)k++;
                        if (k !== j) {
                            stateCopy[i][k] = stateCopy[i][j];
                            stateCopy[i][j] = null;
                            this.moved = true;
                            transitions.push({
                                id: stateCopy[i][k].id,
                                type: "move",
                                from: [
                                    i,
                                    j
                                ],
                                to: [
                                    i,
                                    k
                                ]
                            });
                        }
                        if (k < stateCopy[i].length - 1 && stateCopy[i][k + 1] !== null && stateCopy[i][k].value === stateCopy[i][k + 1].value && !merged[k + 1]) {
                            transitions.push({
                                id: stateCopy[i][k].id,
                                type: "merge",
                                from: [
                                    i,
                                    k
                                ],
                                to: [
                                    i,
                                    k + 1
                                ],
                                mergeIntoId: stateCopy[i][k + 1].id
                            });
                            stateCopy[i][k + 1].value *= 2;
                            this.score += stateCopy[i][k + 1].value;
                            stateCopy[i][k] = null;
                            merged[k + 1] = true;
                            this.moved = true;
                        }
                    }
                }
                return {
                    newState: stateCopy,
                    transitions: transitions,
                    moved: this.moved
                };
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var stateCopy = this.state.map(function(row) {
                    return row.map(function(cell) {
                        return cell ? (0, $ad1c00e896d27009$export$71511d61b312f219)({}, cell) : null;
                    });
                });
                var transitions = [];
                this.moved = false;
                for(var j = 0; j < stateCopy[0].length; j++){
                    var merged = [
                        false,
                        false,
                        false,
                        false
                    ];
                    for(var i = 0; i < stateCopy.length; i++){
                        if (stateCopy[i][j] === null) continue;
                        var k = i;
                        while(k > 0 && stateCopy[k - 1][j] === null)k--;
                        if (k !== i) {
                            stateCopy[k][j] = stateCopy[i][j];
                            stateCopy[i][j] = null;
                            this.moved = true;
                            transitions.push({
                                id: stateCopy[k][j].id,
                                type: "move",
                                from: [
                                    i,
                                    j
                                ],
                                to: [
                                    k,
                                    j
                                ]
                            });
                        }
                        if (k > 0 && stateCopy[k - 1][j] !== null && stateCopy[k][j].value === stateCopy[k - 1][j].value && !merged[k - 1]) {
                            transitions.push({
                                id: stateCopy[k][j].id,
                                type: "merge",
                                from: [
                                    k,
                                    j
                                ],
                                to: [
                                    k - 1,
                                    j
                                ],
                                mergeIntoId: stateCopy[k - 1][j].id
                            });
                            stateCopy[k - 1][j].value *= 2;
                            this.score += stateCopy[k - 1][j].value;
                            stateCopy[k][j] = null;
                            merged[k - 1] = true;
                            this.moved = true;
                        }
                    }
                }
                return {
                    newState: stateCopy,
                    transitions: transitions,
                    moved: this.moved
                };
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var stateCopy = this.state.map(function(row) {
                    return row.map(function(cell) {
                        return cell ? (0, $ad1c00e896d27009$export$71511d61b312f219)({}, cell) : null;
                    });
                });
                var transitions = [];
                this.moved = false;
                for(var j = 0; j < stateCopy[0].length; j++){
                    var merged = [
                        false,
                        false,
                        false,
                        false
                    ];
                    for(var i = stateCopy.length - 1; i >= 0; i--){
                        if (stateCopy[i][j] === null) continue;
                        var k = i;
                        while(k < stateCopy.length - 1 && stateCopy[k + 1][j] === null)k++;
                        if (k !== i) {
                            stateCopy[k][j] = stateCopy[i][j];
                            stateCopy[i][j] = null;
                            this.moved = true;
                            transitions.push({
                                id: stateCopy[k][j].id,
                                type: "move",
                                from: [
                                    i,
                                    j
                                ],
                                to: [
                                    k,
                                    j
                                ]
                            });
                        }
                        if (k < stateCopy.length - 1 && stateCopy[k + 1][j] !== null && stateCopy[k][j].value === stateCopy[k + 1][j].value && !merged[k + 1]) {
                            transitions.push({
                                id: stateCopy[k][j].id,
                                type: "merge",
                                from: [
                                    k,
                                    j
                                ],
                                to: [
                                    k + 1,
                                    j
                                ],
                                mergeIntoId: stateCopy[k + 1][j].id
                            });
                            stateCopy[k + 1][j].value *= 2;
                            this.score += stateCopy[k + 1][j].value;
                            stateCopy[k][j] = null;
                            merged[k + 1] = true;
                            this.moved = true;
                        }
                    }
                }
                return {
                    newState: stateCopy,
                    transitions: transitions,
                    moved: this.moved
                };
            }
        },
        {
            key: "defineStep",
            value: function defineStep(param, direction) {
                var _param = (0, $efec029548ccee7f$export$71511d61b312f219)(param, 2), rowIndex = _param[0], columnIndex = _param[1];
                var currentItem = this.state[rowIndex][columnIndex];
                var currentRow = this.state[rowIndex];
                var currentColumn = this.state.map(function(row) {
                    return row[columnIndex];
                });
                var step = 0;
                switch(direction){
                    case "left":
                        for(var i = columnIndex - 1; i >= 0; i--){
                            if (currentRow[i] === 0) step++;
                            else if (currentRow[i] === currentItem) return step + 1;
                            else break;
                        }
                        return step;
                    case "right":
                        for(var i1 = columnIndex + 1; i1 < currentRow.length; i1++){
                            if (currentRow[i1] === 0) step++;
                            else if (currentRow[i1] === currentItem) return step + 1;
                            else break;
                        }
                        return step;
                    case "up":
                        for(var i2 = rowIndex - 1; i2 >= 0; i2--){
                            if (currentColumn[i2] === 0) step++;
                            else if (currentColumn[i2] === currentItem) return step + 1;
                            else break;
                        }
                        return step;
                    case "down":
                        for(var i3 = rowIndex + 1; i3 < currentColumn.length; i3++){
                            if (currentColumn[i3] === 0) step++;
                            else if (currentColumn[i3] === currentItem) return step + 1;
                            else break;
                        }
                        return step;
                }
            }
        },
        {
            key: "start",
            value: function start() {
                this.born();
                this.born();
                this.status = "playing";
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.state = [
                    [
                        null,
                        null,
                        null,
                        null
                    ],
                    [
                        null,
                        null,
                        null,
                        null
                    ],
                    [
                        null,
                        null,
                        null,
                        null
                    ],
                    [
                        null,
                        null,
                        null,
                        null
                    ]
                ];
                this.status = "idle";
                this.score = 0;
                this.nextCellId = 1;
            }
        },
        {
            key: "check",
            value: function check() {
                for(var i = 0; i < this.state.length; i++)for(var j = 0; j < this.state[i].length; j++){
                    var current = this.state[i][j];
                    if (current !== null && current.value >= 2048) {
                        this.status = "win";
                        return;
                    }
                    if (!current) return;
                    if (j < this.state[i].length - 1) {
                        var rightCell = this.state[i][j + 1];
                        if (rightCell !== null && rightCell.value === current.value) return;
                    }
                    if (i < this.state.length - 1) {
                        var downCell = this.state[i + 1][j];
                        if (downCell !== null && downCell.value === current.value) return;
                    }
                }
                this.status = "lose";
            }
        },
        {
            key: "born",
            value: function born() {
                var emptyCells = [];
                for(var i = 0; i < 4; i++){
                    for(var j = 0; j < 4; j++)if (this.state[i][j] === null) emptyCells.push([
                        i,
                        j
                    ]);
                }
                if (emptyCells.length === 0) return;
                var _emptyCells_Math_floor = (0, $efec029548ccee7f$export$71511d61b312f219)(emptyCells[Math.floor(Math.random() * emptyCells.length)], 2), row = _emptyCells_Math_floor[0], col = _emptyCells_Math_floor[1];
                var value = Math.random() < 0.1 ? 4 : 2;
                var clearStateCell = {
                    id: this.nextCellId++,
                    value: value
                };
                this.state[row][col] = clearStateCell;
                var spawnTransition = {
                    id: clearStateCell.id,
                    type: "spawn",
                    to: [
                        row,
                        col
                    ],
                    value: value
                };
                return spawnTransition;
            }
        },
        {
            key: "performMove",
            value: function performMove(direction) {
                var moveResult;
                switch(direction){
                    case "LEFT":
                        moveResult = this.moveLeft();
                        break;
                    case "RIGHT":
                        moveResult = this.moveRight();
                        break;
                    case "UP":
                        moveResult = this.moveUp();
                        break;
                    case "DOWN":
                        moveResult = this.moveDown();
                        break;
                    default:
                        return {
                            newState: this.state,
                            transitions: [],
                            moved: false
                        };
                }
                if (moveResult.moved) {
                    this.state = moveResult.newState;
                    var spawnTransition = this.born();
                    moveResult.transitions.push(spawnTransition);
                    this.check();
                }
                return moveResult;
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$button = document.querySelector(".button");
var $197cd56b15c33885$var$field = document.querySelector(".game-field");
Z;
var $197cd56b15c33885$var$scoreElement = document.querySelector(".game-score");
var $197cd56b15c33885$var$bestScoreElement = document.querySelector(".best-score");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$ANIMATION_DURATION = 100;
var $197cd56b15c33885$var$CELL_OFFSET = 83;
var $197cd56b15c33885$var$prevMoveEnded = true;
$197cd56b15c33885$var$bestScoreElement.textContent = localStorage.getItem("bestScore") || 0;
function $197cd56b15c33885$var$saveScore() {
    localStorage.setItem("bestScore", $197cd56b15c33885$var$game.getScore());
}
function $197cd56b15c33885$var$animateAndRender(result) {
    result.transitions.forEach(function(t) {
        var cell = document.getElementById("cell-".concat(t.id));
        if (!cell) return;
        if (t.type === "move" || t.type === "merge") cell.style.transform = "translate(".concat(t.to[1] * $197cd56b15c33885$var$CELL_OFFSET, "px, ").concat(t.to[0] * $197cd56b15c33885$var$CELL_OFFSET, "px)");
    });
    setTimeout(function() {
        result.transitions.forEach(function(t) {
            if (t.type === "merge") {
                var disappearingCell = document.getElementById("cell-".concat(t.id));
                var cell = document.getElementById("cell-".concat(t.mergeIntoId));
                if (disappearingCell) disappearingCell.remove();
                if (cell) {
                    var cellObject = $197cd56b15c33885$var$game.state[t.to[0]][t.to[1]];
                    var newValue = cellObject ? cellObject.value : 0;
                    cell.textContent = newValue;
                    cell.className = "cell cell--".concat(cell.textContent);
                }
            }
            if (t.type === "spawn") {
                var cell1 = $197cd56b15c33885$var$createCellElement(t.value, t.to[0], t.to[1], t.id);
                $197cd56b15c33885$var$field.appendChild(cell1);
            }
        });
        $197cd56b15c33885$var$scoreElement.textContent = $197cd56b15c33885$var$game.getScore();
        if ($197cd56b15c33885$var$game.getScore() > parseInt($197cd56b15c33885$var$bestScoreElement.textContent)) {
            $197cd56b15c33885$var$bestScoreElement.textContent = $197cd56b15c33885$var$game.getScore();
            $197cd56b15c33885$var$saveScore();
        }
        if ($197cd56b15c33885$var$game.status === "lose") $197cd56b15c33885$var$messageLose.classList.remove("hidden");
        if ($197cd56b15c33885$var$game.status === "win") $197cd56b15c33885$var$messageWin.classList.remove("hidden");
        $197cd56b15c33885$var$prevMoveEnded = true;
    }, $197cd56b15c33885$var$ANIMATION_DURATION);
}
function $197cd56b15c33885$var$gameCallback(e) {
    if ([
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown"
    ].includes(e.key)) e.preventDefault();
    if ($197cd56b15c33885$var$game.status !== "playing") return;
    if ($197cd56b15c33885$var$prevMoveEnded) {
        var result;
        var direction = null;
        if (e.type === "keydown" && e.key && [
            "ArrowLeft",
            "ArrowRight",
            "ArrowUp",
            "ArrowDown"
        ].includes(e.key)) direction = e.key.replace("Arrow", "").toUpperCase();
        if ([
            "LEFT",
            "RIGHT",
            "UP",
            "DOWN"
        ].includes(direction)) result = $197cd56b15c33885$var$game.performMove(direction);
        else return;
        if (result.moved) {
            $197cd56b15c33885$var$prevMoveEnded = false;
            $197cd56b15c33885$var$animateAndRender(result);
        }
    }
}
function $197cd56b15c33885$var$createCellElement(value, row, col, id) {
    var cell = document.createElement("div");
    cell.id = "cell-".concat(id);
    cell.className = "cell cell--".concat(value);
    cell.textContent = value;
    cell.style.transform = "translate(".concat(col * 83, "px, ").concat(row * 83, "px)");
    return cell;
}
function $197cd56b15c33885$var$clearBoard() {
    var cells = $197cd56b15c33885$var$field.querySelectorAll(".cell");
    cells.forEach(function(cell) {
        return cell.remove();
    });
}
function $197cd56b15c33885$var$initialiseBoard(boardState) {
    for(var i = 0; i < boardState.length; i++)for(var j = 0; j < boardState[i].length; j++){
        var cellObj = boardState[i][j];
        var value = cellObj ? cellObj.value : 0;
        if (value !== 0) {
            var cell = $197cd56b15c33885$var$createCellElement(value, i, j, cellObj.id);
            $197cd56b15c33885$var$field.appendChild(cell);
        }
    }
}
$197cd56b15c33885$var$button.addEventListener("click", function() {
    if ($197cd56b15c33885$var$game.status !== "idle") {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$clearBoard();
        $197cd56b15c33885$var$button.textContent = "Start";
        $197cd56b15c33885$var$button.classList.remove("restart");
        $197cd56b15c33885$var$button.classList.add("start");
        $197cd56b15c33885$var$scoreElement.textContent = $197cd56b15c33885$var$game.getScore();
        $197cd56b15c33885$var$messageStart.classList.remove("hidden");
        $197cd56b15c33885$var$messageLose.classList.add("hidden");
        $197cd56b15c33885$var$messageWin.classList.add("hidden");
        document.removeEventListener("keydown", $197cd56b15c33885$var$gameCallback);
        if ($197cd56b15c33885$var$game.status === "idle" && $197cd56b15c33885$var$button.textContent === "Start") return;
    }
    if ($197cd56b15c33885$var$button.textContent === "Start") {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$button.textContent = "Restart";
        $197cd56b15c33885$var$button.classList.remove("start");
        $197cd56b15c33885$var$button.classList.add("restart");
        $197cd56b15c33885$var$messageStart.classList.add("hidden");
        $197cd56b15c33885$var$initialiseBoard($197cd56b15c33885$var$game.getState());
        $197cd56b15c33885$var$scoreElement.textContent = $197cd56b15c33885$var$game.getScore();
        document.addEventListener("keydown", $197cd56b15c33885$var$gameCallback);
    }
});

})();
//# sourceMappingURL=index.6d3d4475.js.map
